var map = {
	"./en/gallery-slide-0-1.png": 35234,
	"./en/gallery-slide-0-2.png": 91321,
	"./en/gallery-slide-1-1.png": 27495,
	"./en/gallery-slide-1-2.png": 24844,
	"./en/gallery-slide-10-1.png": 27931,
	"./en/gallery-slide-10-2.png": 65952,
	"./en/gallery-slide-2-1.png": 81140,
	"./en/gallery-slide-2-2.png": 2607,
	"./en/gallery-slide-3-1.png": 36049,
	"./en/gallery-slide-3-2.png": 31290,
	"./en/gallery-slide-4-1.png": 46534,
	"./en/gallery-slide-4-2.png": 71421,
	"./en/gallery-slide-5-1.png": 90811,
	"./en/gallery-slide-5-2.png": 12480,
	"./en/gallery-slide-6-1.png": 80136,
	"./en/gallery-slide-6-2.png": 33347,
	"./en/gallery-slide-7-1.png": 19605,
	"./en/gallery-slide-7-2.png": 33854,
	"./en/gallery-slide-8-1.png": 99722,
	"./en/gallery-slide-8-2.png": 40801,
	"./en/gallery-slide-9-1.png": 79759,
	"./en/gallery-slide-9-2.png": 57300,
	"./ru/1 921.jpg": 48508,
	"./ru/2 991.jpg": 53426,
	"./ru/2 992.jpg": 63325,
	"./ru/3 991.jpg": 62051,
	"./ru/33 1.jpg": 66896,
	"./ru/4 1.jpg": 96638,
	"./ru/44 1.jpg": 24130,
	"./ru/5 1.jpg": 91939,
	"./ru/55 1.jpg": 90416,
	"./ru/6 (1) 1.jpg": 67890,
	"./ru/6 1.jpg": 5276,
	"./ru/9 10.jpg": 10263,
	"./ru/99 1.jpg": 72824,
	"./ru/Screenshot 2024-11-07 at 16.27.07 1.jpg": 96589,
	"./ru/Screenshot 2024-11-07 at 16.27.42 1.jpg": 20128,
	"./ru/gallery-slide-0-1.jpg": 80620,
	"./ru/gallery-slide-0-1.webp": 44757,
	"./ru/gallery-slide-0-2.webp": 45000,
	"./ru/gallery-slide-1-1.webp": 45158,
	"./ru/gallery-slide-1-2.webp": 93063,
	"./ru/gallery-slide-2-1.webp": 53711,
	"./ru/gallery-slide-2-2.webp": 94414,
	"./ru/gallery-slide-3-1.webp": 30784,
	"./ru/gallery-slide-3-2.webp": 25453,
	"./ru/gallery-slide-4-1.webp": 77385,
	"./ru/gallery-slide-4-2.webp": 83116,
	"./ru/gallery-slide-5-1.webp": 96202,
	"./ru/gallery-slide-5-2.webp": 5547,
	"./ru/gallery-slide-6-1.webp": 41651,
	"./ru/gallery-slide-6-2.webp": 96306,
	"./ru/gallery-slide-7-1.webp": 47524,
	"./ru/gallery-slide-7-2.webp": 68161,
	"./ru/gallery-slide-8-1.webp": 46333,
	"./ru/gallery-slide-8-2.webp": 3504,
	"./ru/офис (2) 1.jpg": 65798,
	"./ru/офис 2 1.jpg": 10987
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91285;